// src/services/projectService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

export const deleteImagesFolder = async (folderId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/project/images-folders/${folderId}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const deleteProject = async (id,force=false) => {
  try {
    if (force) {
      const response = await axiosInstance.delete(`${API_URL}/project/${id}?force=true`);
      return response;
    }
    const response = await axiosInstance.delete(`${API_URL}/project/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const exportProject = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project/export/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getImagesFolders = async (projectId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project/images-folders/${projectId}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const getProjects = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Obtener un proyecto por su ID
export const getProjectById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project/${id}`);
    if (!response.mediaItems) {
      response.mediaItems = [];
    }
    if ((!response.crmList || response.crmList.length === 0) && (response.crm ?? '')!== '') {
      response.crmList = [{
        integration: 'base',
        crm: response.crm || "",
        config: response.crmConfig || ""
      }];
    } else if (!response.crmList) {
      response.crmList = [];
    }
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const importProject = async (content) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/project/import`, content);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const importUnits = async (formData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/project/import-units`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Crear un nuevo proyecto
export const saveProject = async (project) => {
  try {
    const newProject = {
      address: project.address,
      city: project.city,
      companyId: project.companyId,
      country: project.country,
      crmList: project.crmList,
      currency: project.currency,
      description: project.description,
      measureUnit: project.measureUnit,
      mediaItems: project.mediaItems || [],
      statusColors: project.statusColors || {},
      name: project.name,
      orbitViewProject: project.orbitViewProject,
      orbitViewAmenities: project.orbitViewAmenities,
      slug: project.slug,
      interestRate: project.interestRate,
      backgroundColor: project.backgroundColor,
      accentColor: project.accentColor,
      showPrices: project.showPrices,
      allowQuote: project.allowQuote,
      economicProfiles: project.economicProfiles || [],
      createdAt: project.createdAt,
    };
    if (project.id) {
      newProject.id = project.id;
    }

    const response = await axiosInstance.put(`${API_URL}/project`, newProject);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const uploadGlbFile = async (formData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/project/upload-glb`, formData);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}

export const uploadImagesFolder = async (projectId, folderName, zipFile) => {
  try {
    const urlRequest = {
      projectId,
      fileName: zipFile.name
    };

    const response = await axiosInstance.post(`${API_URL}/project/signed-url`, urlRequest);
    const s3Url = response;

    await uploadFileToS3(s3Url, zipFile);

    const unzipRequest = {
      projectId,
      folderName,
      fileName: zipFile.name
    };

    await axiosInstance.post(`${API_URL}/project/unzip-image-folder`, unzipRequest);

    return { status: "success", message: "Carpeta de imágenes subida correctamente" };
  } catch (error) {
    console.error(" Error en uploadImagesFolder:", error.response?.data || error.message);
    throw new Error(error.message);
  }
};

const uploadFileToS3 = async (uploadUrl, file) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type, 
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error('Error al subir el archivo a S3');
  }
};

export const uploadTourZipFile = async (projectId, tourName,zipFile) => {
  try {
    const urlRequest = {
      projectId,
      fileName: zipFile.name
    };

    const response = await axiosInstance.post(`${API_URL}/project/signed-url`, urlRequest);
    const s3Url = response;

    await uploadFileToS3(s3Url, zipFile);

    const unzipRequest = {
      projectId,
      tourName,
      fileName: zipFile.name
    };

    return await axiosInstance.post(`${API_URL}/project/unzip-tour-folder`, unzipRequest);
  } catch (error) {
    throw new Error(error.message);
  }
}

